"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactTracking = require("react-tracking");

var _Link = _interopRequireDefault(require("../../../elements/link/Link"));

var _stitches = require("../../../stitches.config");

var MoreInformationWrapper = (0, _stitches.styled)('div', {
  marginLeft: 'auto',
  marginRight: 'auto',
  paddingLeft: '15px',
  paddingRight: '15px',
  textAlign: 'center',
  width: '75%',
  '@desktop': {
    paddingLeft: '25px',
    paddingRight: '25px'
  }
});
var InformationHeading = (0, _stitches.styled)('h6', {
  fontSize: '$small',
  margin: '0'
});
var InformationParagraph = (0, _stitches.styled)('div', {
  marginBottom: '8px',
  marginTop: '20px',
  a: {
    textDecoration: 'underline'
  },
  '@tablet': {
    a: {
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'underline'
      }
    }
  }
});
var ShowHide = (0, _stitches.styled)('div', {
  fontSize: '$xxLarge',
  fontWeight: '$medium',
  textAlign: 'center',
  '&:hover': {
    cursor: 'pointer'
  }
});
/**
 * A component to display more information below the wizard navigation buttons.
 * Can display even more information through a +/- toggle.
 */

var MoreInformation = function MoreInformation(_ref) {
  var category = _ref.category,
      expandableText = _ref.expandableText,
      sectionNumber = _ref.sectionNumber,
      text = _ref.text;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      showExpandedText = _useState2[0],
      setShowExpandedText = _useState2[1];

  var _useTracking = (0, _reactTracking.useTracking)(),
      trackEvent = _useTracking.trackEvent;

  var trackEvents = function trackEvents(gaEventAction, gaEventLabel) {
    trackEvent({
      gaEventAction: gaEventAction,
      gaEventLabel: gaEventLabel,
      gaEventNonInteraction: false,
      sf2_section_label: category,
      sf2_section_number: sectionNumber
    });
  };

  var onLinkClick = function onLinkClick(_ref2) {
    var _content$;

    var content = _ref2.content;
    trackEvents("".concat(category, " more information"), (_content$ = content[0]) === null || _content$ === void 0 ? void 0 : _content$.value);
  };

  var informationRenderer = function informationRenderer(content, index) {
    switch (content.nodeType) {
      case 'heading-6':
        return /*#__PURE__*/_react.default.createElement(InformationHeading, {
          key: content.content[0].value
        }, content.content.map(informationRenderer));

      case 'hyperlink':
        return /*#__PURE__*/_react.default.createElement("div", {
          key: content.data.uri
        }, /*#__PURE__*/_react.default.createElement(_Link.default // eslint-disable-line jsx-a11y/anchor-is-valid
        , {
          newTab: true,
          linkType: "external",
          name: "".concat(content.content[0].value, " link"),
          path: content.data.uri,
          onClick: function onClick() {
            onLinkClick(content);
          }
        }, content.content.map(informationRenderer)));

      case 'paragraph':
        {
          return /*#__PURE__*/_react.default.createElement(InformationParagraph, {
            key: "".concat(index, "-").concat(content.content[0].value)
          }, content.content.map(informationRenderer));
        }

      case 'text':
        return content.value;

      default:
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
    }
  };

  var toggleExpandableText = function toggleExpandableText() {
    // TODO: analytics
    setShowExpandedText(!showExpandedText);

    if (!showExpandedText) {
      trackEvents("".concat(category, " more information"), "".concat(category, "-not-sure"));
    }
  };

  var handleKeyClick = function handleKeyClick(event) {
    if (event.key === ' ' || event.code === 'Space' || event.keyCode === '32' || event.key === 'Enter') {
      toggleExpandableText();
    }
  };

  return /*#__PURE__*/_react.default.createElement(MoreInformationWrapper, null, text.content.map(informationRenderer), expandableText && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(ShowHide, {
    id: "toggle-expandable-information",
    tabIndex: 0,
    onClick: toggleExpandableText,
    onKeyDown: handleKeyClick
  }, showExpandedText ? '—' : '+'), showExpandedText && expandableText.content.map(informationRenderer)));
};

MoreInformation.defaultProps = {
  expandableText: null
};
var _default = MoreInformation;
exports.default = _default;